import React from "react"
import type { ReactNode } from "react"

export type VisuallyHiddenProps = {
  children: ReactNode
} & React.HTMLAttributes<HTMLSpanElement>

export default function VisuallyHidden({ children, ...props }: VisuallyHiddenProps) {
  return (
    <span className="sr-only" {...props}>
      {children}
    </span>
  )
}

